<template>
  <div class="template-wrap prod-tile-tooltip-template">
    <div class="main_subject">
      <div class="group-1">
        <span>{{ data.subject }}</span>
      </div>
      <span
        ><gc-status-chip
          :status="data.FriendlyStatus"
          v-if="data.FriendlyStatus"
      /></span>
    </div>

    <div class="subject">
      <span>SO #{{ data.SalesOrderCode }}</span>
      <span
        ><gc-status-chip
          :status="data.TransportStatus"
          v-if="data.TransportStatus"
      /></span>
    </div>

    <div class="product">
      <span>{{ data.ProductCode }}</span>
      <span>{{ data.ProductDescription1 }}</span>
    </div>

    <div class="data-line">
      <div class="left">
        <span>Customer</span>
        <span> {{ data.CustomerName }} </span>
      </div>
      <div class="ordered">
        <span>Ordered</span>
        <span>
          {{ getFormattedQty(data.SalesOrderStockUMQuantity) }}
          {{ data.StockUM }}
        </span>
      </div>
      <div class="right">
        <span>Date</span>
        <span>{{ getFormattedDate(data.SalesOrderShipDate) }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { formatNumber } from "devextreme/localization";
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.00");
    },
    getFormattedDate(value) {
      return new Date(value).toShortDateString();
    },
  },
};
</script>

<style lang="scss">
.e-tooltip-wrap {
  width: auto;
  .prod-tile-tooltip-template {
    width: auto;
    display: flex;
    flex-direction: column;

    .main_subject {
      // border-bottom: 2px solid;
      // margin-bottom: 2px;
      // padding-bottom: 1px;

      .group-1 span {
        font-family: Roboto;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0%;
        color: var(--Colors-Text-text-placeholder, #667085);
      }
    }
    .main_subject,
    .subject,
    .customer {
      display: flex;
      justify-content: space-between;
      // font-size: 14px;
    }

    .subject {
      padding-top: 5px;
      > span:first-child {
        font-family: Inter;
        font-weight: 600;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0%;
        color: var(--colors-text-text-primary-900, #101828);
      }
    }

    .product {
      padding-top: 5px;
      display: flex;
      justify-content: space-between;

      > span:first-child {
        font-family: Inter;
        font-weight: 600;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0%;
        color: var(--colors-text-text-primary-900, #101828);
      }

      > span:last-child {
        padding-left: 20px;
        font-family: Roboto;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0%;
        text-align: right;
        color: var(--Colors-Text-text-placeholder, #667085);
        width: 150px;
      }
    }
    .data-line {
      padding-top: 5px;
      display: flex;
      justify-content: space-between;

      > div {
        display: flex;
        flex-direction: column;
        padding: 0;

        > span:first-child {
          font-family: Roboto;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          letter-spacing: 0%;
          color: var(--Colors-Text-text-placeholder, #667085);
        }

        > span:last-child {
          font-family: Roboto;
          font-weight: 500;
          font-size: 12px;
          line-height: 18px;
          letter-spacing: 0%;
          color: var(--colors-text-text-secondary-700, #323842);
        }
      }

      .right {
        text-align: right;
      }

      .ordered {
        text-align: center;
        padding: 0 8px;
      }
    }
  }
}
</style>
